

const productCarousel = document.querySelectorAll('.products-carousel');
if (productCarousel) {
	productCarousel.forEach(carousel => {
		const swiper = new Swiper(carousel, {
			loop: false,
			navigation: {
				nextEl: carousel.closest( '.products-carousel-wrap' ).querySelector('.slide-nav--next'),
				prevEl: carousel.closest( '.products-carousel-wrap' ).querySelector('.slide-nav--prev'),
			},
			slidesPerView: 2,
			spaceBetween: 8,
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 21,
				},
			},
		});
	});

}

const reviewsCarousel = document.querySelectorAll('.reviews-carousel');
if (reviewsCarousel) {
	reviewsCarousel.forEach(carousel => {
		const swiper = new Swiper(carousel, {
			loop: false,
			navigation: {
				nextEl: carousel.closest( '.reviews-carousel-wrap' ).querySelector('.slide-nav--next'),
				prevEl: carousel.closest( '.reviews-carousel-wrap' ).querySelector('.slide-nav--prev'),
			},
			slidesPerView: 1,
			spaceBetween: 8,
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 17,
				},
			},
		});
	});

}
function categoriesInit() {
	const categoriesCarousel = document.querySelectorAll('.categories-carousel');
	if (categoriesCarousel) {
		categoriesCarousel.forEach(carousel => {
			const swiper = new Swiper(carousel, {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 8,
				pagination: {
					el: carousel.querySelector('.swiper-pagination'),
					clickable: true,
				},
				breakpoints: {
					640: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
				},
				on: {
					init(sw) {
						if (sw.slides.length <= sw.params.slidesPerView) {
							carousel.classList.add('is-static');
						} else {
							carousel.classList.add('is-swiper');
						}
					}
				}
			});
		});
	}
}

setTimeout(categoriesInit(), 500);




function headerInit() {// fold .header__topline when .header is scroll down and unfold when scroll up. add delay to avoid flickering

	let lastScrollTop = 0;
	const header = document.querySelector('.header');
  const menu = document.querySelector('.header__nav');
	const topline = document.querySelector('.header__topline-wrap');
	const toplineScrollHeight = topline ? topline.scrollHeight + 'px' : '0px';
	window.addEventListener('scroll', function() {

    // STOP HEADER SCROLLING WHEN SEARCH IS ACTIVE
    if (header && header.classList.contains('search-active')) {
      header.classList.remove('scrolled'); // keep header open
      return; // ❗ exit scroll handler completely
    }

    // STOP HEADER SCROLLING WHEN MENU IS ACTIVE
    if (menu && menu.classList.contains('active')) {
      header.classList.remove('scrolled'); // keep header open
      return; // ❗ exit scroll handler completely
    }

		let st = window.pageYOffset || document.documentElement.scrollTop;
		if (st > lastScrollTop) {
			// downscroll code
			if (header && topline && st > 200) {
				header.classList.add('scrolled');
				document.querySelector( '.mini-cart' ).classList.remove('open');
			}
		}
		else {
			// upscroll code
			if (header && topline) {
				header.classList.remove('scrolled');
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}, false);
}

headerInit();


// collect header height and set css variable --header-height to use it in css
function setHeaderHeightVar() {
	const header = document.querySelector('.header');
	if (header) {
		const headerHeight = header.offsetHeight + 'px';
		document.documentElement.style.setProperty('--header-height', headerHeight);
	}
}
setTimeout(() => {
	setHeaderHeightVar();
}, 1);
window.addEventListener('resize', setHeaderHeightVar);


const navToggle = document.querySelector('.nav-toggle');
if (navToggle) {
	navToggle.addEventListener('click', function() {
		const nav = document.querySelector('.header__nav');
		this.classList.toggle('active');
		if (nav) {
			nav.classList.toggle('active');
			if (nav.classList.contains('active')) {
				disableScrollExcept('.header__nav');
        document.body.classList.add("no-scroll");
			} else {
				enableScroll('.header__nav');
        document.body.classList.remove("no-scroll");

				document.querySelectorAll( '.nav-dropdown' ).forEach( dd => {
					dd.classList.remove( 'active' );
				} );
			}
		}
	});
}

const hasChild = document.querySelectorAll('.header__nav ul li.has-child');
if (navToggle) {
	hasChild.forEach(item => {
		item.addEventListener('click', function(e) {
			const nav = document.querySelector('.header__nav');
			if (e.target.closest('.nav-dropdown__label-mob')) {
				return;
			}
			item.querySelector('.nav-dropdown').classList.toggle('active');
			if (item.querySelector('.nav-dropdown').classList.contains('active')) {
				disableScrollExcept('.nav-dropdown');
				// scroll nav to top
				nav.scrollTop = 0;

				nav.style.overflow = 'hidden';
				nav.style.touchAction = 'none';
			} else {
				nav.style.overflow = '';
				nav.style.touchAction = '';
				disableScrollExcept('.header__nav');
			}
		});
	});
}

const ddClose = document.querySelectorAll('.nav-dropdown__label-mob');
if (ddClose) {
	ddClose.forEach(item => {
		item.addEventListener('click', function(e) {
			const nav = document.querySelector('.header__nav');
			e.preventDefault();
			const parent = item.closest('.has-child');
			if (parent) {
				parent.querySelector('.nav-dropdown').classList.toggle('active');
				if (item.closest( 'li' ).querySelector('.nav-dropdown').classList.contains('active')) {
					disableScrollExcept('.nav-dropdown');
					nav.style.overflow = 'hidden';
					nav.style.touchAction = 'none';
				} else {
					nav.style.overflow = '';
					nav.style.touchAction = '';
					disableScrollExcept('.header__nav');
				}
			}
		});
	});
}

const cartToggle = document.querySelector('.js-cart-toggle');
const miniCart = document.querySelector('.mini-cart');
const miniCartClose = document.querySelectorAll('.js-cart-close');
if (cartToggle && miniCart) {
	cartToggle.addEventListener('click', function(e) {
		const nav = document.querySelector('.header__nav');
		const navToggle = document.querySelector('.nav-toggle');
		nav.classList.remove('active');
		navToggle.classList.remove('active');
		miniCart.classList.toggle('open');
	});

  miniCart.addEventListener("mouseleave", (event) => {
    event.preventDefault();
    setTimeout(() => {
      miniCart.classList.remove('open');
    }, 8000);
  })

  cartToggle.addEventListener('mouseenter', function (e) {
    const nav = document.querySelector('.header__nav');
    const navToggle = document.querySelector('.nav-toggle');
    nav.classList.remove('active');
    navToggle.classList.remove('active');
    miniCart.classList.add('open');
  });

	document.addEventListener( 'click', ( e ) => {
		if (!e.target.closest( '.mini-cart' ) && !e.target.classList.contains( 'js-cart-toggle' ) && !e.target.closest( '.js-cart-toggle' )) {
			miniCart.classList.remove('open');
			enableScroll('.header__nav');
		}
	});
}
if (miniCartClose) {
	miniCartClose.forEach( btn => {
		btn.addEventListener('click', function(e) {
      e.preventDefault();
			miniCart.classList.remove('open');
		});
	});
}

function disableScrollExcept(allowedSelector) {
	const allowed = document.querySelector(allowedSelector);
	document.body.style.overflow = 'hidden';
	document.body.style.position = 'relative';
	document.body.style.touchAction = 'none';
	if (allowed) {
		allowed.style.overflow = 'auto';
		allowed.style.touchAction = 'auto';
	}
}
function enableScroll(allowedSelector) {
	const allowed = document.querySelector(allowedSelector);
	if (allowed) {
		allowed.style.overflow = '';
		allowed.style.touchAction = '';
	}
	document.body.style.overflow = '';
	document.body.style.position = '';
	document.body.style.touchAction = '';
}

const searchInput = document.querySelector('.header__search input:not([type=checkbox]):not([type=radio])');
if (searchInput) {
	isFieldFilled(searchInput);
	searchInput.addEventListener('keyup', function(e) {
		isFieldFilled(this);
	});
}

const searchClear = document.querySelector('.header__search-clear');
const header = document.querySelector('.header');
if (searchClear && searchInput) {
	searchClear.addEventListener('click', function(e) {
		e.preventDefault();
		searchInput.value = '';
		isFieldFilled(searchInput);
    header.classList.remove('search-active');
	});
}

function isFieldFilled(input) {
	if (input.value.length > 0) {
		input.classList.add('filled');
	} else {
		input.classList.remove('filled');
	}
}

// check all fields on page load
document.addEventListener('DOMContentLoaded', function() {
	const inputs = document.querySelectorAll('.input-wrap input, .input-wrap textarea');
	inputs.forEach(input => {
		isFieldFilled(input);
		input.addEventListener( 'keyup', function(e) {
			input.classList.remove('error');
			isFieldFilled(input);
		});
	});
});

const productGalleryNav = document.querySelector('.product-gallery__nav');
const productGalleryMain = document.querySelector('.product-gallery__main .swiper-slider');
if (productGalleryNav && productGalleryMain) {
	const galleryNav = new Swiper('.product-gallery__nav', {
		direction: 'horizontal',
		slidesPerView: 'auto',
		freeMode: true,
		spaceBetween: 9,
		watchSlidesProgress: true,
		breakpoints: {
			992: {
				spaceBetween: 20,
				direction: 'vertical',
			},
		},
	});

	const galleryMain = new Swiper('.product-gallery__main  .swiper-slider', {
		spaceBetween: 10,
		thumbs: {
			swiper: galleryNav,
		},
		pagination: {
			el: productGalleryMain.closest( '.product-gallery__main' ).querySelector('.swiper-pagination'),
			clickable: true,
		},
		breakpoints: {
			990: {
				spaceBetween: 20,
				pagination: {
					el: productGalleryMain.closest( '.product-gallery__main' ).querySelector('.swiper-pagination'),
					clickable: true,
				},
			},
		},
	});
}

const faqList = document.querySelectorAll('.faq-list__head');
if (faqList) {

	let active = document.querySelectorAll('.faq-list__item.active');
	if (active) {
		active.forEach(item => {
			item.querySelector('.faq-list__body').style.height = item.querySelector('.faq-list__body').scrollHeight + 'px';
		});
	}

	faqList.forEach(head => {
		head.addEventListener('click', function(e) {
			e.preventDefault();
			let item = head.closest('.faq-list__item');
			item.classList.toggle('active');
			let content = item.querySelector('.faq-list__body');
			if ( item.classList.contains('active') ) {
				content.style.height = content.scrollHeight + 'px';
			} else {
				content.style.height = '0px';
			}
		});
	});
}

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".collection-grid__filters-list_item");

  items.forEach((item) => {
    const isToggle = item.classList.contains("toggle");
    const bioToggleInput = item.querySelector('input#bio-toggle') || null;

    item.addEventListener("click", (e) => {
      // Ignore clicks inside details
      if (e.target.closest(".collection-grid__filters-list_item_content")) return;

      e.preventDefault();

      // 1️⃣ If this is a NORMAL item:
      if (!isToggle) {
        // Close ONLY other normal items
        items.forEach((el) => {
          if (el !== item && !el.classList.contains("toggle")) {
            el.classList.remove("is-open");
          }
        });

        // Toggle itself
        item.classList.toggle("is-open");
      }

      // 2️⃣ If this is a TOGGLE item
      else {
        // Toggle ONLY itself
        item.classList.toggle("is-open");
        // Do NOT close anything else
      }

      // BIO toggle logic
      if (bioToggleInput) {
        bioToggleInput.checked = !bioToggleInput.checked;
        bioToggleInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // 3️⃣ Clicking outside closes ONLY normal items
  document.addEventListener("click", (e) => {
    const isInside = e.target.closest(".collection-grid__filters-list_item");

    if (!isInside) {
      items.forEach((item) => {
        if (!item.classList.contains("toggle")) {
          item.classList.remove("is-open");
        }
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".collection-grid__filters-list-mobile-wrapper");
  const overlay = document.querySelector(".js-overlay");
  const openBtn = document.querySelector(".js-open-mobile-filters");
  const closeBtn = document.querySelector(".collection-grid__filters-list-mobile-header__close");

  const submenuPanels = document.querySelectorAll(".mobile-filter-submenu");

  // MAIN DRAWER OPEN

  if (openBtn) {
    openBtn.addEventListener("click", () => {
      drawer.classList.add("is-open");
      overlay.classList.add("is-visible");
      document.body.classList.add("no-scroll");
    });
  }


  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    document.body.classList.remove("no-scroll");

    submenuPanels.forEach(panel => panel.classList.remove("is-open"));
  }

  if (closeBtn && overlay) {
    closeBtn.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);
  }


  // SUBMENU OPEN
  document.querySelectorAll(".js-filter-category").forEach(item => {
    if (item) {
      item.addEventListener("click", () => {
        const target = item.dataset.filter;
        const submenu = document.querySelector(`#submenu-${target}`);

        if (submenu) submenu.classList.add("is-open");
      });
    }
  });

  // SUBMENU CLOSE
  document.querySelectorAll(".mobile-filter-submenu__back").forEach(btn => {
    if (btn) {
      btn.addEventListener("click", () => {
        btn.closest(".mobile-filter-submenu").classList.remove("is-open");
      });
    }
  });
});

function headerTopline() {
	if (window.matchMedia( '(max-width: 991px)' ).matches) {
		const slider = document.querySelector( '.header__topline-wrapper' );
		if (slider.classList.contains('swiper-slider')) {
			return;
		}
		slider.classList.add('swiper-slider');
		const toplineChild = document.querySelectorAll( '.header__topline-wrapper > *' );
		slider.innerHTML = '';
		const sliderWrapper = document.createElement('div');
		sliderWrapper.classList.add( 'swiper-wrapper' );
		slider.appendChild( sliderWrapper );
		toplineChild.forEach(slide => {
			slide.classList.add( 'swiper-slide' );
			slider.querySelector('.swiper-wrapper').appendChild( slide );
		});


		setTimeout(() => {
			console.log('asd');
			const swiper = new Swiper(slider, {
				loop: true,
				slidesPerView: 1,
				freeMode: false,
				spaceBetween: 32,
				speed: 700,
				allowTouchMove: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				}
			});
		}, 100);
	} else {
		const slider = document.querySelector( '.header__topline-wrapper' );
		if (slider.classList.contains('swiper-slider')) {
			const slides = document.querySelectorAll( '.header__topline-wrapper .swiper-slide' );
			slider.innerHTML = '';
			slides.forEach(slide => {
				slide.classList.remove( 'swiper-slide' );
				slider.appendChild( slide );
			});
			slider.classList.remove('swiper-slider');
			slider.classList.remove('swiper-initialized');
			document.querySelectorAll('.header__topline-wrapper > *').forEach(slide => {
				slide.style.width = 'auto';
				slide.style.married = '0';
			});
		}
	}
}

headerTopline();

window.addEventListener('resize', headerTopline);


// .categories-carousel__nav like cursor on .categories-carousel
const categoriesCarousel = document.querySelector('.categories-carousel');

const categoriesNav = document.querySelector('.categories-carousel__nav');
if (categoriesCarousel && categoriesNav) {
	categoriesCarousel.addEventListener('mousemove', function(e) {
		const rect = categoriesCarousel.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		categoriesNav.style.left = x + 'px';
		categoriesNav.style.top = y + 'px';
	});
	categoriesCarousel.addEventListener('mouseleave', function(e) {
		categoriesNav.classList.remove('active');
	});

	categoriesCarousel.addEventListener('mouseenter', function(e) {
		categoriesNav.classList.add('active');
	});
}

const checkboxes = document.querySelectorAll('input[type="checkbox"]');

if (checkboxes) {
	checkboxes.forEach(checkbox => {
		checkbox.addEventListener('change', function(e) {
			this.classList.remove('error');
		});
	});
}

// animate .icon when in viewport wish delay using IntersectionObserver
const icons = document.querySelectorAll('.banner-layer__ico, .banner__foot-emote .icon, .banner-emote .icon, .text-image__pct-inner, .banner-layer__pct-inner');
if (icons) {
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const icon = entry.target;
				const delay = icon.getAttribute('data-animate-delay') || 100;
				setTimeout(() => {
					icon.classList.add('in-view');
				}, delay);
				observer.unobserve(icon);
			}
		});
	}, {
		threshold: 0.1
	});

	icons.forEach(icon => {
		observer.observe(icon);
	});
}


// animate text when in viewport using IntersectionObserver
const animatedTexts = document.querySelectorAll('.banner__title, .banner__desc, .section-title, .text-image__title, .text-image__desc, .banner-layer__title, .banner-layer__desc, .banner-layer__foot');
if (animatedTexts) {
	animatedTexts.forEach(text => {
		text.classList.add('fade-up');
	});

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const text = entry.target;
				const delay = text.getAttribute('data-animate-delay') || 0;
				setTimeout(() => {
					text.classList.add('in-view');
				}, delay);
				observer.unobserve(text);
			}
		});
	}, {
		threshold: 0.1
	});

	animatedTexts.forEach(text => {
		observer.observe(text);
	});
}


// product quantity selector
const qtySelectors = document.querySelectorAll('.product-summary__quantity');
if (qtySelectors) {
	qtySelectors.forEach(selector => {
		const input = selector.querySelector('input');
		const btnPlus = selector.querySelector('.js-product-summary__plus');
		const btnMinus = selector.querySelector('.js-product-summary__minus');
		btnPlus.addEventListener('click', function(e) {
			e.preventDefault();
			let currentValue = parseInt(input.value);
			if (!isNaN(currentValue)) {
				input.value = currentValue + 1;
				input.dispatchEvent(new Event('change'));
			}

			// enable minus button if value is greater than 1
			if (parseInt(input.value) > 1) {
				btnMinus.classList.remove('disabled');
			}

			// optional: limit max value to 100
			if (parseInt(input.value) >= 100) {
				input.value = 100;
				btnPlus.classList.add('disabled');
			} else {
				btnPlus.classList.remove('disabled');
			}
		});
		btnMinus.addEventListener('click', function(e) {
			e.preventDefault();
			let currentValue = parseInt(input.value);
			if (!isNaN(currentValue) && currentValue > 1) {
				input.value = currentValue - 1;
				input.dispatchEvent(new Event('change'));
			}

			// disable minus button if value is 1
			if (parseInt(input.value) <= 1) {
				btnMinus.classList.add('disabled');
			} else {
				btnMinus.classList.remove('disabled');
			}
		});
	});
}

const qtyInputs = document.querySelectorAll('.product-summary__quantity input');
if (qtyInputs) {
	qtyInputs.forEach(input => {
		const btnPlus = input.closest('.product-summary__quantity').querySelector('.js-product-summary__plus');
		const btnMinus = input.closest('.product-summary__quantity').querySelector('.js-product-summary__minus');
		input.addEventListener('blur', function(e) {
			let value = parseInt(this.value);
			if (value > 100) {
				this.value = 100;
			} else if (isNaN(value) || value < 1) {
				this.value = 1;
			} else {
				this.value = value;
			}

			// enable/disable buttons based on value
			if (parseInt(this.value) <= 1) {
				btnMinus.classList.add('disabled');
			} else {
				btnMinus.classList.remove('disabled');
			}

			if (parseInt(this.value) >= 100) {
				btnPlus.classList.add('disabled');
			} else {
				btnPlus.classList.remove('disabled');
			}
		});
	});
}

// move .nav-toggle to .header__grid for landscape tablets
function moveNavToggle() {
	const navToggle = document.querySelector('.nav-toggle');
	const headerGrid = document.querySelector('.header__grid');
	const headerTopline = document.querySelector('.header__center');
	if (window.matchMedia( '(max-width: 1199px) and (min-width: 768px)' ).matches) {
		headerGrid.appendChild(navToggle);
	} else {
		headerTopline.appendChild(navToggle);
	}
}
setTimeout(() => {
	moveNavToggle();
}, 1);
window.addEventListener('resize', moveNavToggle);

// add to .scroll-panel class active if .product-summary__form not in viewport (on load and on scroll)
const scrollPanel = document.querySelector('.scroll-panel');
const productForm = document.querySelector('.product-summary__form');
function checkProductFormInView() {
	const reviewsWidget = document.querySelector('.FloatingWidget-prefix .R-LauncherButton');
	if (scrollPanel && productForm) {
		const rect = productForm.getBoundingClientRect();
		let panelHeight = scrollPanel.scrollHeight + 24;
		if (rect.bottom < 0 || rect.top > window.innerHeight) {
			scrollPanel.classList.add('active');
			if (reviewsWidget) {
				reviewsWidget.classList.add('active');
				reviewsWidget.style.transform = 'translateY(-'+ panelHeight + 'px)';
			}
		} else {
			scrollPanel.classList.remove('active');
			if (reviewsWidget) {
				reviewsWidget.classList.remove('active');
				reviewsWidget.style.transform = 'translateX(0px)';
			}
		}
	}
}
window.addEventListener('scroll', checkProductFormInView);
window.addEventListener('load', checkProductFormInView);
